export default "__VITE_ASSET__C92sMJDk__"